enum AttendanceStatusEnum {
  ACCOMPLISHED = 'accomplished',
  NOT_ACCOMPLISHED = 'not_accomplished',
  EFFECTED = 'effected',
  NOT_EFFECTED = 'not_effected',
  UNPRODUCTIVE = 'unproductive',
}

export default AttendanceStatusEnum;
